<template>
	<div class="flex justify-between py-2">
		<span>{{ name }}</span>
		<div
			class="
				self-center
				pl-2
				pr-2
				rounded-full
				inline-flex
				items-center
				text-pink
				font-medium
			"
            :class='{"text-pink": isTop, "text-blue": !isTop}'
			:style="{
				background: isTop
					? 'rgba(var(--vs-pink),.15)'
					: 'rgba(var(--vs-blue),.15)',
			}"
		>
			{{ rating.toFixed(2) }}
			<!--<feather-icon
				:icon="isTop ? 'ArrowUpIcon' : 'ArrowDownIcon'"
				:class='{"text-pink": isTop, "text-blue": !isTop}'
				svgClasses="h-5 w-5"
			></feather-icon>-->
		</div>
	</div>
</template>

<script>
export default {
	props: {
		ship: {
			type: Object,
			required: true,
		},
		field: {
			type: String,
			required: true,
		},
		deltaPeriod: {
			type: String,
			validator: (val) => ["new_mid", "mid_old", "new_old"].includes(val),
		},
		category: {
			type: String,
			default: 'overall'
		}
	},
	computed: {
		isTop() {
			return this.field.includes("flop") ? false : true;
		},
        name() {
            return this.getObj()[this.field + '_name']
        },
        rating() {
            return (0.000001 + 1*this.getObj()[this.field + '_rating'])
        },
        reviews() {
            return this.getObj()[this.field + '_reviews']
        }
	},
    methods: {
        getObj() {
			let k = 'delta_' + this.deltaPeriod + '.' + this.category;
			return this.ship[k];
        }
    }
};
</script>